import API from "@/api"

export default {

    async list(params) {
        let data = await API.DEPARTMENT.List(params)
        this.department.list = data || []
    }
}